// extracted by css-extract-rspack-plugin
export default {"DashCardVisualization":"Q0_wa","VirtualDashCardOverlayText":"drjtH"};